import {
	makeStyles,
	shorthands
} from "@fluentui/react-components";

export const useStyle = makeStyles({
	searchOrAddContainer: {
        paddingRight: "50px",
		marginTop: "20px"
    },
    contactSearch: {
        ...shorthands.flex(1),
    },
    contactSearchOnAddContact: {
        ...shorthands.margin(0, 0, "10px"),
        width: "65%"
    },
    addContactSwitchContainer: {
        ...shorthands.margin("10px", 0, "20px")
    },
    addContactSwitchLabel: {
        fontWeight: "bold"
    },
    addContactSwitch: {
        '>label': {
            ...shorthands.padding(0)
        }
    }
});
